export const PropertyState = {
    Add: 0,
    Update: 1,
    Del: 2
};

export const PropertySchemaType = {
    System: 0,
    UserSystem: 1,
    User: 2
}

export class PropertySchemaViewModel {
    constructor(p) {
        if (p) {
            Object.assign(this, p);
        }
    }

    Abstract;           // boolean;
    children = [];      // Array<PropertySchemaViewModel>;
    ChildSchemaCode;    // string;
    DefaultValue;       // string;
    DisplayName;        // string;
    FullName;           // string;
    Indexed;            // boolean;
    ViewIndexed;        // boolean;
    IsPublished;        // boolean;
    IsReserved;         // boolean;
    ItemName;           // string;
    LogicType;          // string;
    LogicTypeName;      // string;
    ParentItemName;     // string;
    ParentProperty;     // string;
    Searchable;         // boolean;
    Trackable;          // boolean;
    PropertyState;      // PropertyState;
    IsDrag = true;
    IsDel = false;
    Type;                  // PropertySchemaType;
    DataFormat;            // string;
    ComponentKey;          // string;
    RelateName;            // string;
    OldName;               // string;
    isExtendField = false;
    ExtendProperty = [];   // Array<PropertySchemaViewModel>
}

export class ItemSchema {
    ChildSchema;   // any;
    DataFormat;    // string
    DefaultValue;  // string;
    DisplayName;   // string;
    FullName;      // string;
    LogicType;     // DataLogicType
    MaxLength = 0;
    Name;          // string;
    OldName;       // string;
    RelateName;    // string;
}

export class DataKeyValue {
    Key;
    Value;
}

export const DataLogicType = {
    Association: 0x2d,
    Attachment: 0x18,
    BizObject: 40,
    BizObjectArray: 0x29,
    BizStructure: 0x2a,
    BizStructureArray: 0x2b,
    Bool: 1,
    BoolArray: 0,
    ByteArray: 20,
    Comment: 0x11,
    DateTime: 5,
    DateTimeArray: 4,
    Decimal: 0x23,
    DecimalArray: 0x24,
    Double: 7,
    DoubleArray: 6,
    GlobalData: 0x2c,
    Guid: 0x21,
    GuidArray: 0x22,
    Html: 30,
    HyperLink: 0x10,
    Int: 9,
    IntArray: 8,
    Long: 11,
    LongArray: 10,
    MultiParticipant: 0x1b,
    Object: 0x1f,
    ShortString: 14,
    SingleParticipant: 0x1a,
    String: 13,
    StringArray: 12,
    TimeSpan: 0x19,
    Unspecified: -1,
    Xml: 0x20,
    Json: 80,
    FormArea: 81,

    properties: {
        0x2d: { code: 'Association' },
        0x18: { code: 'Attachment' },
        40: { code: 'BizObject' },
        0x29: { code: 'BizObjectArray' },
        0x2a: { code: 'BizStructure' },
        0x2b: { code: 'BizStructureArray' },
        1: { code: 'Bool' },
        0: { code: 'BoolArray' },
        20: { code: 'ByteArray' },
        0x11: { code: 'Comment' },
        5: { code: 'DateTime' },
        4: { code: 'DateTimeArray' },
        0x23: { code: 'Decimal' },
        0x24: { code: 'DecimalArray' },
        7: { code: 'Double' },
        6: { code: 'DoubleArray' },
        0x2c: { code: 'GlobalData' },
        0x21: { code: 'Guid' },
        0x22: { code: 'GuidArray' },
        30: { code: 'Html' },
        0x10: { code: 'HyperLink' },
        9: { code: 'Int' },
        8: { code: 'IntArray' },
        11: { code: 'Long' },
        10: { code: 'LongArray' },
        0x1b: { code: 'MultiParticipant' },
        0x1f: { code: 'Object' },
        14: { code: 'ShortString' },
        0x1a: { code: 'SingleParticipant' },
        13: { code: 'String' },
        12:{ code: 'StringArray' },
        0x19:{ code: 'TimeSpan' },
        //-1:{ code:'Unspecified'},
        0x20:{ code: 'Xml' },
        80:{ code: 'Json' },
        81:{ code: 'FormArea' }
    }
}